export default "__VITE_ASSET__BEvV3I$1__"